/**
 * MedicBlu pattern: mouse viewport top 100px'inde header otomatik reveal +
 * scroll position track (transparent header'ı en üstte tutmak için).
 */
(function () {
  if (window.__noendyHeaderMouseReveal) return;
  window.__noendyHeaderMouseReveal = true;

  const REVEAL_ZONE = 100; // px from viewport top
  const SCROLL_THRESHOLD = 10; // px — bu eşikten sonra `is-scrolled` class eklenir

  function init() {
    const header = document.querySelector('.section-header');
    if (!header) return;

    // Mouse top reveal (hidden state için — opsiyonel, always mode'da rarely tetiklenir)
    document.addEventListener('pointermove', (event) => {
      if (event.clientY < REVEAL_ZONE && header.classList.contains('shopify-section-header-hidden')) {
        header.classList.remove('shopify-section-header-hidden');
        header.classList.add('shopify-section-header-sticky', 'animate');
      }
    }, { passive: true });

    // Scroll position tracker: html.is-scrolled toggle.
    // Anasayfa hero üstündeyken transparent kalır (scrollY === 0).
    // Scroll yapılınca solid background.
    const updateScrollState = () => {
      document.documentElement.classList.toggle('is-scrolled', window.scrollY > SCROLL_THRESHOLD);
    };
    updateScrollState();
    window.addEventListener('scroll', updateScrollState, { passive: true });

    // Header bottom edge'i her zaman güncel tut — search modal'ın `top` değeri
    // bu CSS variable'a bağlı, header padding/shrink değişimlerine adapte olur.
    // .header__icons içeren <header> element'i — section wrapper değil, gerçek header.
    const headerEl = header.querySelector('.header') || header;
    const updateHeaderBottom = () => {
      const rect = headerEl.getBoundingClientRect();
      const bottom = Math.round(rect.bottom);
      // Header gizliyken bottom ≤ 0 olabilir — bu kötü değeri ezmeyelim,
      // son iyi değer korunsun. (noendy-header-search.js:97 ile tutarlı)
      if (bottom > 0) {
        document.documentElement.style.setProperty('--noendy-header-bottom', `${bottom}px`);
      }
    };
    updateHeaderBottom();
    window.addEventListener('scroll', updateHeaderBottom, { passive: true });
    window.addEventListener('resize', updateHeaderBottom, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(updateHeaderBottom);
      ro.observe(headerEl);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
